export default function Hero() {
  const handleScroll = (href: string) => {
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden"
    >
      <img
        src="https://readdy.ai/api/search-image?query=Artistic%20manga%20themed%20abstract%20background%20with%20warm%20coral%20and%20cream%20tones%2C%20soft%20gradient%2C%20subtle%20Japanese%20comic%20panel%20line%20art%20texture%2C%20elegant%20and%20minimal%20composition%2C%20digital%20art%20style%20with%20gentle%20atmospheric%20lighting%2C%20no%20text%2C%20suitable%20for%20website%20hero%20background%2C%20warm%20and%20inviting%20feeling&width=1600&height=900&seq=hero-bg-manga-01&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-background-50"></div>

      <div className="relative z-10 w-full px-4 md:px-6 py-20 md:py-28">
        <div className="max-w-[1400px] mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-500/10 border border-primary-300/30 mb-5">
              <i className="ri-fire-line text-primary-500 text-sm"></i>
              <span className="text-xs font-medium text-primary-600 whitespace-nowrap">下拉式 · 免费全集 · 手机优化</span>
            </div>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading text-foreground-900 leading-tight mb-3">
              女神漫画网 | 下拉式在线阅读与免费全集
            </h1>

            <p className="text-base md:text-lg text-primary-500 font-medium mb-6">
              无需翻页，流畅滚动，沉浸式追漫新体验
            </p>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-[620px] mx-auto lg:mx-0 mb-8">
              女神漫画网专为漫画爱好者打造，汇聚海量韩漫、日漫热门作品。采用下拉式在线阅读模式，滚动即可连续阅读完整章节，
              彻底告别翻页打断。本站每日更新热门全集，从恋爱甜漫到奇幻热血，满足你多样化的追漫需求。
              当前站内主打韩漫下拉式全集与日漫下拉式免费阅读两大主题，为你提供最顺畅的手机漫画阅读之旅。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-10 mb-8">
              <div className="text-center">
                <div className="flex items-center justify-center gap-1.5">
                  <span className="text-2xl md:text-3xl font-heading text-accent-500">2000+</span>
                </div>
                <p className="text-xs text-foreground-500 mt-1">部漫画全集</p>
              </div>
              <div className="w-px h-10 bg-background-300 hidden sm:block"></div>
              <div className="text-center">
                <div className="flex items-center justify-center gap-1.5">
                  <span className="text-2xl md:text-3xl font-heading text-accent-500">每日更新</span>
                </div>
                <p className="text-xs text-foreground-500 mt-1">韩漫·日漫同步</p>
              </div>
              <div className="w-px h-10 bg-background-300 hidden sm:block"></div>
              <div className="text-center">
                <div className="flex items-center justify-center gap-1.5">
                  <span className="text-2xl md:text-3xl font-heading text-accent-500">免费畅读</span>
                </div>
                <p className="text-xs text-foreground-500 mt-1">全集无限制</p>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#ranking"
                onClick={(e) => { e.preventDefault(); handleScroll('#ranking'); }}
                className="inline-flex items-center gap-2 px-8 py-3 bg-primary-500 text-background-50 font-medium rounded-full hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer text-sm"
              >
                <i className="ri-fire-line"></i>
                查看热门榜单
              </a>
              <a
                href="#cards"
                onClick={(e) => { e.preventDefault(); handleScroll('#cards'); }}
                className="inline-flex items-center gap-2 px-8 py-3 border border-background-300 text-foreground-700 font-medium rounded-full hover:bg-background-100 transition-colors duration-200 whitespace-nowrap cursor-pointer text-sm"
              >
                <i className="ri-bookmark-line"></i>
                精选推荐
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-[280px] h-[380px] md:w-[340px] md:h-[460px] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Elegant%20manga%20style%20illustration%20of%20a%20beautiful%20female%20character%20with%20flowing%20hair%2C%20soft%20warm%20lighting%2C%20artistic%20composition%20with%20decorative%20Japanese%20elements%2C%20delicate%20line%20art%2C%20modern%20manhwa%20aesthetic%2C%20cream%20and%20coral%20color%20palette%2C%20portrait%20orientation%2C%20dreamy%20atmosphere%2C%20no%20text%20or%20speech%20bubbles&width=800&height=1100&seq=hero-visual-manga&orientation=portrait"
                alt="女神漫画网主视觉 - 下拉式漫画阅读体验"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 rounded-2xl ring-1 ring-inset ring-background-300/40"></div>
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-background-50/90 via-background-50/20 to-transparent h-24"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}